<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px">
      <el-button @click="search()">查询</el-button>
      <el-button @click="exportExcel()">导出</el-button>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="考勤年月">
          <el-date-picker
            v-model="params.month"
            type="month"
            placeholder="选择月份">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="所在项目">
          <el-select v-model="params.project_ids" placeholder="选择项目" multiple filterable>
            <el-option v-for="item in projectList" :key="item.id" :label="item.value" :value="item.id">{{item.value}}</el-option>
          </el-select>
<!--          <el-input size="mini" placeholder="" v-model="params.department_name" clearable></el-input>-->
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          <el-input size="mini" placeholder="请输入姓名" v-model="params.name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="手机号码">
          <el-input size="mini" placeholder="请输入手机号码" v-model="params.phone" clearable></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>


    <div style="margin-top: 10px;">
<!--      <span style="color:red">加载中...</span>-->
    </div>
    <table v-loading="loading" class="month-table" cellspacing="0" cellpadding="0" border="0">
      <thead>
      <tr class="month-table-header">
        <th class="fixed" style="width: 300px;">项目</th>
        <th class="fixed" style="width: 80px;">员工</th>
<!--        <th class="fixed" style="width: 80px;">岗位</th>-->
        <th class="fixed" style="width: 80px;">状态</th>
        <th style="width: 80px;">实际出勤</th>
        <th style="width: 80px;">计划出勤</th>
        <th style="width: 80px;">忘记打卡</th>
        <th style="width: 80px;">补卡次数</th>
<!--        <th style="width: 80px;">迟到分钟</th>-->
        <th v-for="(item, index) in dayList" class="day-head"><span
          v-html="item.title"></span></th>
        <th style="width: 160px;">备注</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in list">
        <td class="fixed">{{ item.project }}</td>
        <td class="fixed">{{ item.name }}</td>
        <td class="fixed">
          <template v-if="item.on_job_status == 0">
            <span style="color: red">离职</span>
          </template>
          <template v-if="item.on_job_status == 1">
            在职
          </template>
          <template v-if="item.on_job_status == 2">
            试用期
          </template>
        </td>
        <td class="fixed">
          <span>{{ item.statistics.actual_attendance }}</span>
        </td>
        <td class="fixed">{{ item.statistics.attendance_required }}</td>
        <td class="fixed">
          <template v-if="item.statistics.forgot_clock_count > 0">
            <span style="color: red">{{ item.statistics.forgot_clock_count }}</span>
          </template>
          <template v-else>
            <span>{{ item.statistics.forgot_clock_count }}</span>
          </template>
        </td>
        <td class="fixed">
          <template v-if="item.statistics.card_replacement_count > 0">
            <span style="color: red">{{ item.statistics.card_replacement_count }}</span>
          </template>
          <template v-else>
            <span>{{ item.statistics.card_replacement_count }}</span>
          </template>
        </td>
<!--        <td class="fixed">-->
<!--          <template v-if="item.statistics.late_minute > 0">-->
<!--            <span style="color: red">{{ item.statistics.late_minute }}</span>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <span>{{ item.statistics.late_minute }}</span>-->
<!--          </template>-->
<!--        </td>-->
        <template v-for="value in item.data">
          <td v-if="value.afternoon == 10" style="background-color: #00E3FF;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger"  @contextmenu.prevent="show(item, value)" >{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 1">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)"  @click="cardReplacement(item,value)" style="color: red">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 3" style="background-color: #FBF86B;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)"  @click="cardReplacement(item,value)">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 2" style="background-color: #FDB5DD;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 4" style="background-color: #BBEF98;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 5" style="background-color: #ebadd7;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 6" style="background-color: #BBEF98;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
          <td v-if="value.afternoon == 7" style="background-color: #ff66ff;">
            <el-tooltip class="item" effect="dark" show-after="5500"
                        :content="'上班卡：' + value.clock_in + ', 下班卡：' + value.clock_out"
                        placement="top-start">
              <div class="el-tooltip__trigger" @contextmenu.prevent="show(item, value)"  @click="clearCardReplacement(item,value)">{{value.afternoon_text}}</div>
            </el-tooltip>
          </td>
        </template>
        <td></td>
      </tr>
      </tbody>
    </table>
    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="params.total"
                   :current-page="params.page"
                   :page-size="params.pageSize"
                   :page-sizes="[20, 50, 100, 500]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

    <el-dialog title="调整考勤" :visible.sync="dialogVisible" width="30%" :before-close="close">
      <span>
        <div>
           <el-radio v-model="formData.editType" label="1">清除打卡记录</el-radio>
           <el-radio v-model="formData.editType" label="2">调整为正常出勤</el-radio>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import Http from "../common/Http";

export default {
  name: 'AttendanceList',
  data() {
    return {
      params: {
        month: "",
        department_name: "",
        name: "",
        phone: "",
        total: 0,
        page: 1,
        pageSize: 20
      },
      formData: {
        editType: ""
      },
      dayList: [],
      projectList: [],
      list: [],
      loading:false,
      dialogVisible: false,
      selectValue : {
        item : {},
        value : {},
      }
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    this.loading = true
    let date = new Date();
    let month = date.getMonth() + 1;
    this.params.month = date.getFullYear() + '-' + month;
    this.dayList = this.getDayList(this.params.month)
    this.getRecordList()
    this.getProjectList()
  },
  methods: {

    search() {
      this.params.page = 1;
      this.getRecordList()
    },
    exportExcel() {
      let params = this.params
      Http.get(Http.getPreBaseURL() + "/oa/Attendance/export", params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    getRecordList() {
      this.dayList = this.getDayList(this.params.month)
      let params = this.params
      Http.get(Http.getPreBaseURL() + '/oa/Attendance/getList', params, res => {
        if (res.code === 0) {
          this.list = res.data.data;
          this.params.page = parseInt(res.data.current_page);
          this.params.pageSize = parseInt(res.data.per_page);
          this.params.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
        this.loading = false
      })
    },
    // 获取项目列表
    getProjectList() {
      let that = this
      Http.get(Http.getPreBaseURL() + '/oa/user/projectList', {}, res => {
        if (res.code === 0) {
          that.projectList = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    // 获取本月日期列表
    getDayList(value) {
      const weekdayTitle = {0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六'}
      const dayNumber = moment(value).daysInMonth()
      let dayList = []
      for (let i = 1; i <= dayNumber; i++) {
        let day = moment(value).format('YYYY-MM') + '-' + (i < 10 ? '0' + i : i)
        let weekday = moment(day).weekday()
        dayList.push({day: day, title: i + '<br>' + weekdayTitle[weekday]})
      }
      return dayList
    },
    // 补卡
    cardReplacement(item, data) {
      let that = this
      this.$confirm('确认补卡：'+ item.name +'的'+ data.date +'补卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.get(Http.getPreBaseURL() + '/oa/Attendance/cardReplacement', {xsc_user_id:item.xsc_user_id, date:data}, res => {
          if (res.code === 0) {
            that.search();
            this.$message.success({
              message: '操作成功',
              type: "success",
            })
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            })
          }
        })
      });
    },
    // 清除补卡
    clearCardReplacement(item, data) {
      let that = this
      this.$confirm('确认清除补卡：'+ item.name +'的'+ data.date +'补卡?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.get(Http.getPreBaseURL() + '/oa/Attendance/clearCardReplacement', {xsc_user_id:item.xsc_user_id, date:data}, res => {
          if (res.code === 0) {
            that.search();
            this.$message.success({
              message: '操作成功',
              type: "success",
            })
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            })
          }
        })
      });
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getRecordList()
    },
    handleSizeChange(val) {
      this.params.pageSize = parseInt(val)
      this.getRecordList()
    },
    // 控制input显示 row 当前行 column 当前列
    show(item, value) {
      this.dialogVisible = true
      this.formData.editType = ""
      this.selectValue.value = value
      this.selectValue.item = item
    },
    // 关闭弹窗
    close() {
      this.dialogVisible = false
    },
    save() {
      let that = this
      let str = ""
      if (this.formData.editType === "") {
        this.$message.error({message: "请选择类型！", type: "error"})
      }
      if (this.formData.editType == 1) {
        str = "是否清除(" + that.selectValue.item.name + ")" + that.selectValue.value.date +"打卡记录"
      }
      if (this.formData.editType == 2) {
        str = "是否将(" + that.selectValue.item.name + ")" + that.selectValue.value.date +"打卡记录调整为正常出勤"
      }

      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          xsc_user_id: that.selectValue.item.xsc_user_id,
          date: that.selectValue.value,
          type: that.formData.editType
        }
        Http.get(Http.getPreBaseURL() + '/oa/Attendance/editRecord', params, res => {
          if (res.code === 0) {
            that.search();
            this.$message.success({
              message: '操作成功',
              type: "success",
            })
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            })
          }
        })
      });
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
$widths: 100px;
.month-table {
  border-color: gray;
  border-collapse: separate;
  user-select: none;
  font-size: 12px;
  min-width: 1200px;
  min-height: 100px;

  tr:hover {
    td.fixed {
      background-color: #dddddd;
      border: 1px solid #ebeef5;
      color: #000;
    }
  }

  th, td {
    min-width: 24px;
    padding: 5px 0px;

    &.fixed {
      position: sticky;
      cursor: pointer;
      z-index: 2;
    }
  }

  th {
    background: #f5f7fa;
    color: #909399;
    border: 1px solid #ebeef5;

    &.hover {
      background-color: #ffebbe;
      color: #333;
    }
  }

  td {
    color: #606266;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    text-align: center;
    overflow: hidden;

    &:first-child {
      border-left: 1px solid #ebeef5;
    }

    &.day-item {
      &.check {
        //background: #fafafa;
        opacity: .5;
      }

      &.changed {
        background: #fd9dca;
        color: #333;
      }

      &.selected {
        background: #409eff;
        color: #409eff;
      }
    }

    &.fixed {
      background-color: #fafafa;
    }

    .work-class-label {
      display: inline-block;
    }
  }

  .department-name {
    box-sizing: border-box;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 78px;
    padding: 0 3px;
    line-height: 20px;
  }

  &.show-department {
    .department-name {
      text-overflow: unset;
      overflow: visible;
      white-space: normal;
      width: 198px;
    }
  }

  .inp {
    box-sizing: border-box;
    width: 100%;
    min-width: 50px;
    text-align: center;
    border: 1px solid #fff;
    outline: none;
    font-size: 12px;
    border-radius: 3px;

    &:hover, &:focus {
      border-color: #ccc;
    }
  }

  .w80 {
    display: inline-block;
    width: 79px;
  }

}

.day-head {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Attendance/list.vue